<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="审批编号：" prop="approvalNumber">
            <el-input v-model="query.approvalNumber" placeholder="请输入审批编号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人信息：" prop="applyInfo">
            <el-input v-model="query.applyInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人身份：">
            <el-select v-model="query.applyLevel" placeholder="请选择" clearable size="small">
              <el-option v-for="item in businessStanding" :key="item.id" :label="item.name" :value="item.level"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请类型：">
            <el-select v-model="query.processingType" placeholder="请选择" clearable size="small">
              <el-option 
                v-for="(item, key) in processingTypeMap" 
                :key="key"
                :label="item.label" 
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="提交时间" :value="1"></el-option>
              <el-option label="抄送时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list">
        <el-table-column label="审批编号" prop="approvalNumber" align="center" fixed>
        </el-table-column>
        <el-table-column label="申请人信息" prop="userPho" align="" fixed>
          <template slot-scope="{row}">
            <div>{{row.submitName}}</div>
            <div>{{row.submitPho}}</div>
          </template>
        </el-table-column>
        <el-table-column label="申请人身份" prop="submitLevelName" align="center" />
        <el-table-column label="申请类型" prop="" align="center">
          <template slot-scope="{row}">
            {{ getProcessingTypeLabel(row.processingType) }}
          </template>
        </el-table-column>
        <el-table-column label="申请内容" prop="userPho" align="">
          <template slot-scope="{row}">
            <div v-if="row.processingType==1">
              <div>{{row.customerName}}({{row.levelName}})</div>
              <div>{{row.customerPho}}</div>
            </div>
            <div v-if="row.processingType==3">
              <div>原身份：{{row.oldIdentityName}}</div>
              <div>调整身份：{{row.levelName}}</div>
            </div>
            <div v-if="row.processingType==4">
              <div>将{{row.customerName}}({{row.levelName}}){{row.customerPho}}</div>
              <div>调整为离职</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="审核备注" prop="auditRemark" align="center" />
        <el-table-column label="审核上传图片" prop="" align="center" width="200">
          <template slot-scope="{row}" v-if="row.auditUrl">
            <div style="display: flex;justify-content: center;" v-if="row.auditUrl">
              <el-image style="width: 60px; height: 50px;margin-right: 4px;" :src="item" :preview-src-list="[item]" v-for="(item,index) in row.auditUrl.split(',')" :key="index"></el-image>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="提交时间" prop="submitTime" sortable align="center" width="200" />
        <el-table-column label="抄送时间" prop="auditTime" sortable align="center" width="200" />
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'
import businessProcessingApi from '@/api/user/businessProcessing'
import customerLevelApi from '@/api/sys/customerLevel'
import enums from '@/utils/enums'
export default {
  components: {
    Pagination,
    // businessQuit,
    // businessAdjust,
    // areaRemove
  },
  data() {
    return {
      popType: null,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // isInternal:1
      },
      sectionList: [],
      dateTime: null,
      activeName: '1',
      businessStanding: []
    }
  },
  computed: {
    processingTypeMap() {
      return enums.getProcessingType()
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getBusinessStanding()
  },
  methods: {
    // 获取申请类型标签
    getProcessingTypeLabel(type) {
      return enums.findEnumLabel(type, this.processingTypeMap) || '未知类型'
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.businessStanding = data.filter(i => [1, 2].includes(i.level))
        console.log('客户身份: ', data, this.businessStanding);
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // this.query.jobStatus=this.activeName==1?1:0
      let query = {
        ...this.query,
      }
      if ([1, 2].includes(this.query.timeType) && this.dateTime) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      // if(this.query.timeType==2 && this.dateTime){
      //   query.operatedTimeStart=this.dateTime[0]
      //   query.operatedTimeEnd=this.dateTime[1]
      // }
      // if(this.query.timeType==3 && this.dateTime){
      //   query.resignationTimeStart=this.dateTime[0]
      //   query.resignationTimeEnd=this.dateTime[1]
      // }
      // delete query.timeType
      // if(!)
      this.listLoading = true
      return businessProcessingApi.getList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDownload() {
      this.$router.push("/export/list?code=FinanceExportDownloadExcel")
    },
  }
}
</script>
